import React from 'react'
import ReactDOM from 'react-dom'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import { compose } from 'redux'

import App from './App'
import Store from './Store'

import * as reducers from './reducers'

import showAppInfo from './services/debug/showAppInfo'
import History from './client/History'

import {
  initializeGA,
  setGAPageView,
} from './services/analytics/google-analytics'

function renderApp(config) {
  const { props, rootElementId, name } = config

  // initializeGA(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_CODE)
  initializeGA(process.env.REACT_APP_GA4_TRACKING_CODE)
  setGAPageView(window.location.pathname + window.location.search)

  showAppInfo().then(appInfo => {
    // eslint-disable-next-line no-console
    console.log(appInfo)
  })

  const rootElement = window.document.getElementById(rootElementId)
  if (!rootElement) {
    throw new Error('Root element not found.')
  }

  const appView = React.createElement(App, {
    ...props,
    name,
  })

  if ('hydrate' in rootElement.dataset) {
    ReactDOM.hydrate(appView, rootElement)
    rootElement.removeAttribute('data-hydrate')
    window.document.documentElement.removeAttribute('data-url')
    return
  }
  ReactDOM.render(appView, rootElement)
}

const HISTORY = new History()

const STORE = new Store({
  reducers: {
    ...reducers,
    router: connectRouter(HISTORY),
  },
  state: {},
  composer:
    process.env.NODE_ENV === 'development' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        })
      : compose,
  middleware: [routerMiddleware(HISTORY)],
})

renderApp({
  name: process.env.REACT_APP_NAME,
  props: {
    history: HISTORY,
    store: STORE,
  },
  rootElementId: process.env.REACT_APP_ROOT_ELEMENT_ID,
})

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
